import { Component } from '@angular/core';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { ResultComponent } from 'projects/app-default/src/app/ui/resut/result.component';
import { ProductViewAddToBasketComponent } from '../../product/product-view-add-to-basket/product-view-add-to-basket.component';
@Component({
    selector: 'lp-add-to-basket',
    templateUrl: './lp-add-to-basket.html',
    standalone: true,
    imports: [TranslationModule, ActionComponent, ResultComponent]
})
export class LpAddToBasketComponent extends ProductViewAddToBasketComponent {}
